import { CATALOG_VALUE_LABELS } from '#max-core'

export default {
  computed: {
    maxLabels () {
      const _ = this._
      const catalog = {}
      for (const [key, title] of Object.entries(CATALOG_VALUE_LABELS)) {
        catalog[key] = _(title)
      }
      return {
        severity: {
          critical: _('Critical'),
          high: _('High'),
          medium: _('Moderate'),
          low: _('Low'),
          info: _('Info')
        },
        kind: {
          seo_audit: _('SEO audit'),
          growth_audit: _('Growth audit'),
          audit: _('Audit'),
          report: _('Report'),
          dashboard: _('Dashboard'),
          health: _('Shop health'),
          interface: _('Tool'),
          custom: _('Johku Max')
        },
        ui: {
          selectAll: _('Select all rows'),
          selectRow: _('Select row'),
          noRows: _('Nothing to show.'),
          working: _('Working...'),
          actions: _('Actions'),
          confirm: _('Confirm'),
          cancel: _('Cancel'),
          failed: _('Something went wrong. Try again.'),
          previous: _('Previous'),
          next: _('Next'),
          more: _('Show more'),
          typeToSearch: _('Type to search'),
          today: _('Today'),
          increase: _('Increase'),
          decrease: _('Decrease'),
          chooseDate: _('Date')
        },
        generated: _('Generated'),
        period: _('Period'),
        showTable: _('Show data table'),
        hideTable: _('Hide data table'),
        showAllRows: _('Show all rows'),
        showFewerRows: _('Show fewer rows'),
        rowsHidden: _('{count} more rows'),
        fix: _('How to fix'),
        affected: _('Affected'),
        all: _('All'),
        effort: {
          quick: _('Quick fix'),
          moderate: _('Moderate effort'),
          involved: _('Larger task')
        },
        impact: {
          high: _('High impact'),
          medium: _('Medium impact'),
          low: _('Low impact')
        },
        degraded: _('This part of the report could not be displayed.'),
        loadingChart: _('Loading chart'),
        chartFailed: _('The chart could not be drawn. The data is shown as a table instead.'),
        category: _('Category'),
        value: _('Value'),
        share: _('Share'),
        series: _('Series'),
        from: _('From'),
        to: _('To'),
        date: _('Date'),
        open: _('Opening value'),
        close: _('Closing value'),
        low: _('Lowest'),
        high: _('Highest'),
        conversion: _('Conversion'),
        opensInNewTab: _('opens in a new tab'),
        noFindings: _('No findings.'),
        diagramFailed: _('The diagram could not be drawn.'),
        copy: _('Copy'),
        copied: _('Copied'),
        selected: _('Text selected'),
        artifact: {
          source_johku_staff: _('Prepared for you by Johku'),
          source_schedule: _('Scheduled report by Johku Max'),
          source_merchant: _('Created with Johku Max'),
          dismiss: _('Dismiss'),
          restore: _('Restore'),
          dismissed: _('You dismissed this. It stays available here until it expires.'),
          unread: _('New')
        },
        catalog
      }
    }
  }
}
